<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <h5> Modifier </h5>
      <p>
        Vous pouvez valider votre modification et passer à la signature des déclarations,
        ou bien poursuivre vos modifications.
      </p>
      <v-auto-complete
        class="my-3"
        label="Ajouter une activité complémentaire"
        placeholder="Développeur"
        :list="researchResult"
        :reset-list="resetList"
        @getlist="searchResults"
        @setitem="setActivity"
      />
    </div>
    <div class="col-12 col-md-9 mx-auto">
      <div
        v-for="activity in activities"
        :key="activity.id"
        class="d-flex p-2 mb-3 fw-bold
          bg-gray-300 rounded-4 justify-content-between"
      >
        {{ activity.name }}
        <font-awesome-icon
          icon="trash"
          class="cursor-pointer"
          style="width:16px; height: 16px"
          @click="removeActivity(activity)"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash-es';
import { mapGetters } from 'vuex';

import { AutoComplete } from '@/components/common/input';

export default {
  name: 'CustomisationActivities',
  components: {
    'v-auto-complete': AutoComplete,
  },
  data() {
    return {
      debouncer: ({ cancel: () => {} }),
    };
  },
  computed: {
    ...mapGetters({
      products: 'rater/products',
      contract: 'contract/get',
      researchResult: 'activities/researchResult',
    }),
    activities() {
      return this.contract.risk.activities || [];
    },
  },
  mounted() {
    this.$store.dispatch('activities/setCustomList', this.contract.grid.id);
  },
  methods: {
    searchResults(value) {
      this.debouncer.cancel();
      const setValue = () => {
        this.$store.dispatch('activities/search', { value });
      };
      this.debouncer = debounce(setValue, 500);
      this.debouncer();
    },
    haveActivity({ id: activityId }) {
      return this.activities.some(({ id }) => id === activityId);
    },
    removeActivity(activity) {
      const value = this.activities.filter(({ id }) => id !== activity.id);
      return this.$store.dispatch('contract/updateSubscription',
        { path: 'risk.activities', value });
    },
    addActivity(activity) {
      const value = this.activities;
      value.push(activity);
      return this.$store.dispatch('contract/updateSubscription',
        { path: 'risk.activities', value });
    },
    setActivity(activity) {
      if (this.haveActivity(activity)) {
        return this.removeActivity(activity);
      }
      return this.addActivity(activity);
    },
    resetList() {
      this.$store.dispatch('activities/setValue', { researchResult: [] });
    },
  },
};
</script>
<style scoped>
  .fs-14 {
    font-size: 14px;
  }
</style>
